export var WELCOME_NEWS_EVENT_TYPES = {
  DISMISS_WELCOME_NEWS: 'DISMISS_WELCOME_NEWS',
  PRESS_WELCOME_NEWS: 'PRESS_WELCOME_NEWS'
};